export async function reloadProjectIntegration({api, projectId, integrationId, onIntegrationRefreshed}) {
    const integrations = await api.listProjectIntegrations({projectId});
    const refreshedIntegration = integrations.find((integration) => integration.id === integrationId);

    if (refreshedIntegration) {
        onIntegrationRefreshed(refreshedIntegration);
    }

    return refreshedIntegration ?? null;
}

export async function refreshOAuthIntegrationResources(parameters) {
    const {api, projectId, integrationId} = parameters;
    await api.refreshProjectOAuthIntegrationResources({projectId, integrationId});
    return reloadProjectIntegration(parameters);
}
